<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconbaoming"></i>
      学生管理
    </div>
    <div class="padding-sm">
      <div class="flex align-center justify-between margin-bottom-sm">
        <div class="flex align-center condition-warpper">
          <el-input
              v-model="stu_name"
              placeholder="请输入姓名"
              class="margin-right-sm"
          ></el-input>
          <el-select v-model="status" placeholder="请选择状态" class="margin-right-sm">
            <el-option label="全部" value=" "></el-option>
            <el-option label="未报到" value="2"></el-option>
            <el-option label="实习中" value="3"></el-option>
            <el-option label="实习结束" value="4"></el-option>
          </el-select>
          <el-button type="primary" @click="onSearch">
            <p class="flex align-center font-size">
              <i class="el-icon-search margin-right-xs"></i>搜索
            </p>
          </el-button>
        </div>
      </div>
      <div class="table-warpper">
        <el-table
            :data="studentList"
            header-row-class-name="table-header"
            row-class-name="table-row"
            alig="center"
            fit
            style="width: 100%"
        >
          <el-table-column width="70" type="index" align="center" label="序号">
          </el-table-column>
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.user_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="身份号">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.stu_idcard }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="隶属院校">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.org_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="实习时间" width="110px">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.start_date }}<br>
                {{ scope.row.end_date }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="实习岗位">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.gw }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <div class="table-item">
                <span v-if=" scope.row.status === 0 ">未报到</span>
                <span v-if="scope.row.status  === 1">实习中</span>
                <span v-if="scope.row.status  === 2">实习结束</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="450">
            <template slot-scope="scope">
              <div class="table-operate">
                <el-button
                    size="medium"
                    type="primary"
                    @click="showItem(scope.row.user_id,scope.row.file_id)"
                >查看详情
                </el-button>
                <el-button
                    v-if="scope.row.status !== 2"
                    size="medium"
                    type="primary"
                    @click="editItem(scope.row,0)"
                >编辑
                </el-button>
                <el-button
                    v-if="scope.row.status === 0"
                    size="medium"
                    type="primary"
                    @click="editItem(scope.row,1)"
                >确认到岗
                </el-button>
                <el-button
                    v-if="scope.row.status === 1"
                    size="medium"
                    type="primary"
                    @click="setItemAppraise(scope.row)"
                >实习评价
                </el-button>
                <el-button
                    v-if="scope.row.status !== 2"
                    size="medium"
                    type="primary"
                    @click="setItemStatus(scope.row)"
                > 实习结束
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            v-if="studentList.length > 0"
            class="page-all"
            background
            :current-page.sync="page"
            :page-size="limit"
            layout="prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <stu-dialog :subdialogDialog="dialog" :setId="setId" :file="file"  @cancelDialog="cancelDialog"/>
    <el-dialog
        :title="editState === 0?'实习编辑':'确认报道'"
        :visible.sync="dialog2"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="600px"
        center>
      <el-form :model="editForm" :rules="editRules" ref="editForm" label-width="120px" v-if="setItem">
        <el-form-item label="实习开始时间" prop="start_date">
          <el-date-picker
              :disabled="setItem.status!== 0"
              style="width: 100%;"
              v-model="editForm.start_date"
              align="right"
              type="date"
              placeholder="请选择实习开始时间"
              :picker-options="pickerOptions1">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="预计结束时间" prop="end_date">
          <el-date-picker
              :disabled="setItem.status!== 0"
              style="width: 100%;"
              v-model="editForm.end_date"
              align="right"
              type="date"
              placeholder="请选择预计结束时间"
              :picker-options="pickerOptions1">
          </el-date-picker>
        </el-form-item>
        <el-form-item
            v-for="(domain, index) in editForm.gw"
            :label="index===0?'实习岗位名称':''"
            :key="index"
            :prop="'gw.' + index "
            :rules="{
      required: true, message: '实习岗位名称不能为空', trigger: 'blur'
    }"
        >
          <div class="flex align-center justify-between">
            <el-input v-model="editForm.gw[index]"></el-input>
            <i class="el-icon-circle-plus font-size-xl margin-left" v-if="index === 0" @click="addGw"></i>
            <i class="el-icon-delete-solid font-size-xl margin-left" v-else @click="deleteGw(index)"></i>
          </div>

        </el-form-item>
        <p v-if="editState === 1" style="text-align: center;color: #e4393c;" class="margin-tb-sm">确认报道后实习时间将锁定，无法修改</p>
        <el-form-item class="flex align-center justify-around" label-width="0">
          <el-button class="padding-lr-xl" @click="cancelDialog">关闭</el-button>
          <el-button v-if="editState === 0" class="padding-lr-xl" type="primary" @click="submitEditForm('editForm')">
            保存
          </el-button>
          <el-button v-if="editState === 1" class="padding-lr-xl" type="primary" @click="submitEditForm('editForm')">
            确认报道
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
        :title="'实习评价'"
        :visible.sync="dialog3"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="600px"
        center>
      <div v-if="setItem">
        <div class="pj-item">
          <h3>{{ setItem.user_name }}</h3>
          <p>实习开始时间：{{ setItem.start_date }} ~ 预计结束时间：{{ setItem.end_date }}</p>
          <p>实习地点：{{ setItem.address }}</p>
        </div>
        <div class="pj-item">
          <h3>实习岗位</h3>
          <p>{{ setItem.gw }}</p>
        </div>
        <div class="pj-item">
          <h3>实习评价</h3>
          <el-form :model="evaluateForm" :rules="evaluateRules" ref="evaluateForm">
            <el-form-item label="" prop="name">
              <el-input type="textarea" v-model="evaluateForm.name" placeholder="请输入实习评价" rows="5"
                        :readonly="!isPj"></el-input>
            </el-form-item>
            <el-form-item class="flex align-center justify-around" label-width="0">
              <el-button class="padding-lr-xl" @click="cancelDialog">关闭</el-button>
              <el-button class="padding-lr-xl" type="primary" v-if="isPj" @click="submitForm('evaluateForm')">提交
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        :title="'实习结束'"
        :visible.sync="dialog4"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="600px"
        center>
      <el-form :model="editForm" :rules="editRules" ref="editForm" label-width="120px" v-if="setItem">
        <el-form-item label="实习结束节点" prop="type">
          <el-radio-group v-model="editForm.type">
            <el-radio :label="1">正常实习结束</el-radio>
            <el-radio :label="2" v-if="setItem.status === 0">未报道</el-radio>
            <el-radio :label="3">提前结束实习</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="实习开始时间" prop="start_date">
          <el-date-picker
              disabled
              style="width: 100%;"
              v-model="editForm.start_date"
              align="right"
              type="date"
              placeholder="请选择实习开始时间"
              :picker-options="pickerOptions1">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="实习结束时间" prop="end_date">
          <el-date-picker
              :disabled="editForm.type === 1"
              style="width: 100%;"
              v-model="editForm.end_date"
              align="right"
              type="date"
              placeholder="请选择实习结束时间"
              :picker-options="pickerOptions1">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="提前结束原因" prop="remark" v-if="editForm.type === 3">
          <el-input v-model="editForm.remark" type="textarea"></el-input>
        </el-form-item>
        <el-form-item
            v-for="(domain, index) in editForm.gw"
            :label="index===0?'实习岗位名称':''"
            :key="index"
            :prop="'gw.' + index "
            :rules="{
      required: true, message: '实习岗位名称不能为空', trigger: 'blur'
    }"
        >
          <div class="flex align-center justify-between">
            <el-input v-model="editForm.gw[index]"></el-input>
            <i class="el-icon-circle-plus font-size-xl margin-left" v-if="index === 0" @click="addGw"></i>
            <i class="el-icon-delete-solid font-size-xl margin-left" v-else @click="deleteGw(index)"></i>
          </div>

        </el-form-item>

        <el-form-item class="flex align-center justify-around" label-width="0">
          <el-button class="padding-lr-xl" @click="cancelDialog">关闭</el-button>
          <el-button class="padding-lr-xl" type="primary" @click="submitEndForm('editForm')">
            保存
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  stationClass,
  volunteerFinish,
  getStudentComment,
  volunteerSign,
  setStudentComment
} from "@/api/practiceBase";
import stuDialog from "@/views/coordinate/page/dialog/stuDialog";

export default {
  name: "student",
  data() {
    return {
      stu_name: "",
      status: "",
      studentList: [],
      page: 1,
      total: 0,
      limit: 10,
      setId: 0,
      setItem: null,
      file:'',
      dialog: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
      editState: 0,
      editForm: {
        type: 1,
        start_date: null,
        end_date: null,
        gw: [],
        remark:'',
      },
      editRules: {
        type: [{required: true, message: '请选择实习结束节点', trigger: 'change'}],
        start_date: [{type: 'date', required: true, message: '请选择实习开始日期', trigger: 'change'}],
        end_date: [{type: 'date', required: true, message: '请选择预计结束时间', trigger: 'change'}],
        gw: [{required: true, message: '请输入实习岗位名称', trigger: 'blur'}],
        remark: [{required: true, message: '请输入提前结束原因', trigger: 'blur'}]
      },


      evaluateForm: {
        name: ''
      },
      evaluateRules: {
        name: [{required: true, message: '请输入拒绝原因', trigger: 'blur'}]
      },
      isPj: true,
    };
  },
  components: {stuDialog},
  created() {
    this.$emit(
        "setIndex",
        this.$route.path,
        "当前位置：岗位管理 - 学生管理",
        true
    );
    this.getList()
  },
  methods: {
    //  获取实习生列表
    async getList() {
      let _list = await stationClass(this.stu_name, this.status, this.$route.query.id, this.page, this.limit)
      this.studentList = _list.data.list
      this.total = _list.data.count
    },
    //  查看学生信息
    showItem(id,file) {
      this.setId = id
      this.file = file
      this.dialog = true
    },
    //  实习编辑显示
    editItem(item, num) {
      this.editState = num
      this.setId = item.id
      this.setItem = item
      this.dialog2 = true
      this.editForm.gw = item.gw.split(',')
      if (item.start_date) {
        this.editForm.start_date = new Date(item.start_date)
        this.editForm.end_date = new Date(item.end_date)
      }

    },
    //  添加删除岗位名称
    addGw() {
      this.editForm.gw.push('')
    },
    deleteGw(index) {
      this.editForm.gw.splice(index, 1)
    },

    //  实习编辑提交
    submitEditForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sureEdit(formName)
        }
      });
    },
    async sureEdit(formName) {
      let _state = await volunteerSign(this.setItem.status  === 0 && this.editState === 0 ? 0 : 1, this.setId, this.$tools.ZHDate(new Date(this.editForm.start_date)), this.$tools.ZHDate(new Date(this.editForm.end_date)), this.editForm.gw.join(','));
      this.$message.success(_state.msg)
      this.$refs[formName].resetFields();
      this.cancelDialog()
      this.getList()
    },

    //  显示评价
    setItemAppraise(item) {
      this.setId = item.id
      this.setItem = item
      this.isPj = item.status === 2 ? false : true
      this.dialog3 = true
      this.getPingjia(item.id)
    },
    //  获取之前的评价
    async getPingjia(id) {
      let _data = await getStudentComment(id)
      if (_data.data) {
        this.evaluateForm.name = _data.data.content
      }
      this.dialog3 = true
    },
    //  提价评价
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await setStudentComment(this.setId,this.evaluateForm.name);
      this.$message.success(_state.msg)
      this.$refs[formName].resetFields();
      this.cancelDialog()
      this.getList()
    },


    //  结束
    setItemStatus(item) {
      if(!item.ping && item.status === 1) return this.$message.error('请先填写实习评价')
      this.setId = item.id
      this.setItem = item
      this.editForm.gw = item.gw.split(',')
      if (item.start_date) {
        this.editForm.start_date = new Date(item.start_date)
        this.editForm.end_date = new Date(item.end_date)
      }
      this.dialog4 = true
    },

    submitEndForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sureSet(formName)
        }
      });
    },

    async sureSet(formName) {
      let _state = await volunteerFinish(this.setId,this.editForm.type, this.$tools.ZHDate(new Date(this.editForm.start_date)), this.$tools.ZHDate(new Date(this.editForm.end_date)), this.editForm.gw.join(','),this.editForm.remark);
      this.$message.success(_state.msg)
      this.$refs[formName].resetFields();
      this.cancelDialog()
      this.getList()
    },
    //  搜索
    onSearch() {
      this.page = 1
      this.getList()
    },

    cancelDialog() {
      this.setId = 0
      this.setItem = null
      this.file = ''

      this.dialog = false
      this.dialog2 = false
      this.dialog3 = false
      this.dialog4 = false
    },
  },
  watch: {
    dialog2() {
      if (!this.dialog2) this.isPj = true
    }
  }
}
</script>

<style scoped lang="scss">
.pj-item {
  padding: 15px 0;
  border-bottom: 1px dashed #eee;

  h3 {
    color: #33ac9f;
    margin-bottom: 10px;
  }

  p {
    line-height: 28px;
  }
}
</style>